import React from "react";

const Card = ({
  children,
  title,
  action,
  padding = "clamp(15px, 2.5vw, 25px)",
  className = "",
  style = {},
  bodyStyle = {},
}) => {
  return (
    <div
      className={`card border-0 ${className}`}
      style={{
        boxShadow: "0 20px 60px rgba(0,0,0,.08)",
        overflow: "hidden",
        background: "#fff",
        padding,
        ...style,
      }}
    >
      {(title || action) && (
        <div className="d-flex justify-content-between align-items-center" style={{
          flexWrap: "wrap",
          gap: "10px",
        }}>
          {title && (
            <span style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#3cb5a0",
            }}>
              {title}
            </span>
          )}
        </div>
      )}
      <div style={bodyStyle}>{children}</div>
    </div>
  );
};

export default Card;